import React from 'react'
import DatePicker from "react-datepicker"
import "react-datepicker/dist/react-datepicker.css"
import { DEFAULT_DATE_FORMAT } from '../constants'

const DateRangeSelector = ({ fromDate, toDate, setFromDate, setToDate }) => {
  return (
    <div className="date_sec">
      {/* FROM Date */}
      <div className="date_lt">
        <div className="calendar-input-wrapper">
          <label htmlFor="from-date">From</label>
          <div className="calendar-input">
            <DatePicker
              id="from-date"
              selected={fromDate}
              onChange={(date) => setFromDate(date)}
              maxDate={toDate}
              placeholderText="Select start date"
              dateFormat={DEFAULT_DATE_FORMAT}
              className="form-control"
            />
            <i className="fas fa-calendar"></i>
          </div>
        </div>
      </div>

      {/* TO Date */}
      <div className="date_rt">
        <div className="calendar-input-wrapper">
          <label htmlFor="to-date">To</label>
          <div className="calendar-input">
            <DatePicker
              id="to-date"
              selected={toDate}
              onChange={(date) => setToDate(date)}
              minDate={fromDate}
              placeholderText="Select end date"
              dateFormat={DEFAULT_DATE_FORMAT}
              className="form-control"
            />
            <i className="fas fa-calendar"></i>
          </div>
        </div>
      </div>
    </div>
  )
}

export default DateRangeSelector 